import { useRetrieveListByGet } from 'src/compass/shared/hooks/reactQuery/useRetrieveListByGet';

export default function useSiteProperties() {
  const query = useRetrieveListByGet({
    url: 'Public/Properties/Site',
    staleTime: Infinity,
  });

  const databaseName = query.data?.databaseName?.toLowerCase();

  const isProductionDatabase = !databaseName || databaseName === 'production';

  return { ...query, isProductionDatabase };
}
